import { Loader } from '@googlemaps/js-api-loader';

common.View.create('crud::form.inputs.Maps', {

    onDOMLoad()
    {
        const loader = new Loader({
            apiKey: this.element.find('.apiKey').text(),
            version: "weekly",
            libraries: ["places"]
        });

        loader
            .load()
            .then((google) => {
                this.initMap(google);
            });

        this.updateMapLink();
    },

    initMap(google)
    {
        // Variables
        let map,
            marker,
            place,
            $lat = this.element.find('#lat').get(0),
            $long = this.element.find('#lng').get(0),
            $zoom = this.element.find('#zoom').get(0),
            myLatLng,
            // service,
            infoWindow;

        if( this.element.find('.map').length ) {
            // Settings
            myLatLng = {lat: parseFloat($lat.value), lng: parseFloat($long.value)};
            infoWindow = new google.maps.InfoWindow();

            map = this.setupMap(google, myLatLng, $zoom);
            marker = this.setMarker(google, map, myLatLng);

            this.mapMarkerDragEnd(google, marker, $lat, $long);
            this.mapDoubleClick(google, map, marker, $lat, $long);
            this.mapDragEnd(google, marker, $lat, $long);
            this.zoomChanged(google, map, $zoom);
        }

        if( this.element.find('#address').length ) {
            let autocomplete = this.setupAutocomplete(google);

            this.placeChanged(google, map, autocomplete, place, marker, $lat, $long);
        }

        // // Search places
        // service = new google.maps.places.PlacesService(map);
        // service.findPlaceFromQuery(request, function (results, status) {
        //     if (status === google.maps.places.PlacesServiceStatus.OK) {
        //         for (var i = 0; i < results.length; i++) {
        //             createMarker(results[i]);
        //         }
        //         map.setCenter(results[0].geometry.location);
        //     }
        // });
        //
        // // Add listener
        // google.maps.event.addListener(marker, 'click', function (event) {
        //     alert(this.position);
        // });
    },

    setupMap(google, myLatLng, $zoom)
    {
        // Get map
        return new google.maps.Map(document.getElementsByClassName('map')[0], {
            zoom: parseInt($zoom.value),
            center: myLatLng
        });
    },

    setMarker(google, map, myLatLng)
    {
        // Set marker
        return new google.maps.Marker({
            position: myLatLng,
            map: map,
            draggable: true,
            title: 'Versleep me!'
        });
    },

    mapMarkerDragEnd(google, marker, $lat, $long)
    {
        // Set the coordinates to the google maps to a hidden field
        google.maps.event.addListener(marker, 'dragend', (event) => {
            // Set lat and lng values on hidden inputs
            $lat.value = event.latLng.lat();
            $long.value = event.latLng.lng();

            this.updateAddressField(event.latLng);
        });
    },

    mapDoubleClick(google, map, marker, $lat, $long)
    {
        // Double click add marker
        google.maps.event.addListener(map, 'dblclick', (event) => {
            // Change marker position
            let positionDoubleclick = event.latLng;

            marker.setPosition(positionDoubleclick);

            // Set lat and lng values on hidden inputs
            $lat.value = event.latLng.lat();
            $long.value = event.latLng.lng();

            this.updateAddressField(positionDoubleclick);
        });
    },

    mapDragEnd(google, marker, $lat, $long)
    {
        // Set the coordinates to the gogole maps to a hidden field
        google.maps.event.addListener(marker, 'dragend', function (event) {
            // Set lat and lng values on hidden inputs
            $lat.value = event.latLng.lat();
            $long.value = event.latLng.lng();
        });
    },

    zoomChanged(google, map, $zoom)
    {
        google.maps.event.addListener(map, 'zoom_changed', () => {
            $zoom.value = map.getZoom();
        });
    },

    setupAutocomplete(google)
    {
        return new google.maps.places.Autocomplete(this.element.find('#address').get(0));
    },

    placeChanged(google, map, autocomplete, place, marker, $lat, $long)
    {
        google.maps.event.addListener(autocomplete, 'place_changed', () => {
            place = autocomplete.getPlace();

            if (!place.geometry) {
                // Inform the user that a place was not found and return.
                return;
            }

            if( $lat && $long ) {
                $lat.value = place.geometry.location.lat();
                $long.value = place.geometry.location.lng();
            }

            // Set map link if available
            if( this.element.find('.mapLink').length ) {
                this.element.find('.mapLink').attr('href', place.url)
                    .removeClass('pointer-events-none');
            }

            if( this.element.find('.map').length ) {
                this.updateMapAutoComplete(map, place, marker);
            }
        });
    },

    updateAddressField(position)
    {
        let addressInput = this.element.find('#address');
    
        if( addressInput.length ) {
            // Perform reverse geocoding for the new position
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({ 'location': position }, function (results, status) {
                if (status === 'OK') {
                    if (results[0]) {
                        // Set the address in the text input
                        addressInput.val(results[0].formatted_address);
                    } else {
                        console.log('No address found');
                    }
                } else {
                    console.log('Geocoder failed due to: ' + status);
                }
            });
        }
    },

    updateMapAutoComplete(map, place, marker)
    {
        // If the place has a geometry, then present it on a map.
        if (place.geometry.viewport) {
            // Use the viewport if it is provided.
            map.fitBounds(place.geometry.viewport);
        } else {
            // Otherwise use the location and set a chosen zoom level.
            map.setCenter(place.geometry.location);
            map.setZoom(17);
        }

        marker.setPosition(place.geometry.location);
    },

    updateMapLink()
    {
        if( !this.element.find('.mapLink').length ) {
            return;
        }

        // Also set map link on initial load
        if( this.element.find('#address').val() !== '') {
            this.element.find('.mapLink').attr('href', 'https://www.google.nl/maps/?q=' + this.element.find('#address').val())
                .removeClass('pointer-events-none');
        }

        // If user has 'prepend or append' icon setup, update link
        this.element.find('#address').on('keyup change', (event) => {
            if( event.target.value === '') {
                this.element.find('.mapLink').attr('href', '')
                    .addClass('pointer-events-none');
            } else {
                this.element.find('.mapLink').attr('href', 'https://www.google.nl/maps/?q=' + event.target.value)
                    .removeClass('pointer-events-none');
            }
        });
    },

});
